import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { BUILD_ITER, BUILD_NOTE, BUILD_AT } from "@/build";

// Iter-145 — bundle audit marker. Lets the user verify which build
// is live from any browser's DevTools console without needing to
// inspect the JS bundle by hand.
// eslint-disable-next-line no-console
console.log(
    `%c OnSetFlow ${BUILD_ITER} %c ${BUILD_NOTE} %c ${BUILD_AT}`,
    "background:#111;color:#fff;padding:2px 6px;border-radius:3px",
    "color:#999;padding:0 4px",
    "color:#666;font-size:10px",
);
window.__OSF_BUILD__ = { iter: BUILD_ITER, note: BUILD_NOTE, at: BUILD_AT };

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
